import { useState } from "react";
import styles from "./HotelMapping.module.css";
import { Building2, Bed } from "lucide-react";
import HotelMappingTab from "../../../../components/Products/Hotels/Mapping/HotelMappingTab";
import RoomMappingTab from "../../../../components/Products/Hotels/Mapping/RoomMappingTab";

const HotelMapping = () => {
  const [activeTab, setActiveTab] = useState("hotel-mapping");

  const tabs = [
    {
      id: "hotel-mapping",
      label: "Hotel Mapping",
      icon: Building2,
      description: "Map supplier hotels to master Hotelbeds hotels"
    },
    {
      id: "room-mapping",
      label: "Room Mapping",
      icon: Bed,
      description: "Map room types to API supplier room codes"
    }
  ];

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h1>Hotel & Room Mapping</h1>
          <p className={styles.subtitle}>
            Manage hotel and room type mappings for seamless inventory synchronization across suppliers
          </p>
        </div>
      </div>

      {/* Tabs Navigation */}
      <div className={styles.tabs}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`${styles.tab} ${activeTab === tab.id ? styles.activeTab : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={18} />
              <div className={styles.tabContent}>
                <span className={styles.tabLabel}>{tab.label}</span>
                <span className={styles.tabDesc}>{tab.description}</span>
              </div>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className={styles.tabPanel}>
        {activeTab === "hotel-mapping" && <HotelMappingTab />}
        {activeTab === "room-mapping" && <RoomMappingTab />}
      </div>
    </div>
  );
};

export default HotelMapping;